module.exports = __webpack_public_path__ + "static/assets/01e3c7568f882f8de5e57b6261b0e24c.svg";